import { useState, useEffect } from 'react';
import { cmsService } from '../../services/cmsService';

const FloatingSocialIcons = () => {
    const [settings, setSettings] = useState<Record<string, string>>({});
    const [showWechatQR, setShowWechatQR] = useState(false);

    useEffect(() => {
        const fetchSettings = async () => {
            try {
                const data = await cmsService.getSiteSettings();
                const settingsMap = data.reduce((acc, item) => {
                    acc[item.setting_key] = item.setting_value;
                    return acc;
                }, {} as Record<string, string>);
                setSettings(settingsMap);
            } catch (error) {
                console.error('Failed to fetch settings:', error);
            }
        };
        fetchSettings();
    }, []);

    const whatsappPhone = settings['social_whatsapp'] || '+254 724 458 752';
    // Clean phone number for WhatsApp link (remove spaces, plus, etc if needed, but wa.me accepts with country code)
    const cleanPhone = whatsappPhone.replace(/[^0-9]/g, '');
    const whatsappUrl = `https://wa.me/${cleanPhone}`;

    const wechatId = settings['social_wechat'] || 'wxid_fla1cmspvhjn22';

    return (
        <>
            <div className="fixed bottom-6 right-6 z-50 flex flex-col gap-4">
                {/* WeChat Icon */}
                <button
                    onClick={() => setShowWechatQR(!showWechatQR)}
                    className="bg-[#09B83E] text-white w-12 h-12 lg:w-14 lg:h-14 flex items-center justify-center rounded-full shadow-lg hover:bg-[#08a536] transition-transform hover:scale-110 cursor-pointer"
                    aria-label="WeChat"
                >
                    <i className="ri-wechat-fill text-2xl lg:text-3xl"></i>
                </button>

                {/* WhatsApp Icon */}
                <a
                    href={whatsappUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="bg-[#25D366] text-white w-12 h-12 lg:w-14 lg:h-14 flex items-center justify-center rounded-full shadow-lg hover:bg-[#128C7E] transition-transform hover:scale-110 cursor-pointer"
                    aria-label="WhatsApp"
                >
                    <i className="ri-whatsapp-line text-2xl lg:text-3xl"></i>
                </a>
            </div>

            {/* WeChat QR Modal / ID Toast */}
            {showWechatQR && (
                <div className="fixed bottom-24 right-6 lg:right-24 z-50 bg-white p-4 rounded-xl shadow-xl border border-gray-100 animate-fade-in w-64">
                    {settings['wechat_qr_url'] ? (
                        <div className="text-center">
                            <p className="text-sm font-semibold mb-2 text-gray-800">Scan to chat on WeChat</p>
                            <img src={settings['wechat_qr_url']} alt="WeChat QR Code" className="w-full h-auto rounded-lg" />
                        </div>
                    ) : (
                        <div className="text-center">
                            <p className="text-sm text-gray-500 mb-1">Our WeChat ID</p>
                            <p className="font-bold text-gray-800 text-lg mb-2">{wechatId}</p>
                            <button
                                onClick={() => {
                                    navigator.clipboard.writeText(wechatId);
                                    alert("WeChat ID copied to clipboard!");
                                }}
                                className="w-full py-2 bg-gray-100 hover:bg-gray-200 text-gray-800 rounded-lg text-sm transition-colors"
                            >
                                <i className="ri-file-copy-line mr-2"></i>Copy ID
                            </button>
                        </div>
                    )}
                    <button
                        onClick={() => setShowWechatQR(false)}
                        className="absolute -top-2 -right-2 bg-gray-800 text-white w-6 h-6 rounded-full flex items-center justify-center hover:bg-black transition-colors"
                    >
                        <i className="ri-close-line text-xs"></i>
                    </button>
                </div>
            )}
        </>
    );
};

export default FloatingSocialIcons;
